import { styled } from "../../../../styles";

/**
 * EN-3040. The count of messages in a thread nobody on the care team has opened.
 *
 * Was an inline div with a hardcoded "1"; it now carries the real count and, per the ticket, only
 * appears from 2 upwards — a single unread is already signalled by the row highlight.
 */
export const UnreadBadge = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: "17px",
  height: "17px",
  marginLeft: "6px",

  borderRadius: "50%",
  backgroundColor: "var(--colors-table-row-messages-circle)",

  color: "$white",
  fontSize: "12px",
  fontWeight: "500",
  textAlign: "center",
});

export const LastMessageCell = styled("div", {
  display: "flex",
  alignItems: "center",
});

/** The Status column's three faces: a CTA when open, plain text otherwise. */
export const CloseThreadButton = styled("button", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  padding: "4px 14px",
  border: "none",
  borderRadius: "14px",
  cursor: "pointer",

  backgroundColor: "$secondary",
  color: "$white",

  fontFamily: "inherit",
  fontSize: "13px",
  fontWeight: "500",
  lineHeight: "20px",
  whiteSpace: "nowrap",

  "&:hover": {
    backgroundColor: "$secondary-dark",
  },

  "&:disabled": {
    cursor: "default",
    opacity: 0.6,
  },
});

export const StatusText = styled("span", {
  fontSize: "14px",
  color: "$charcoal",

  variants: {
    failed: {
      true: { color: "$error" },
    },
  },
});

export const TitleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
});

export const NewDataCOntainer = styled("div", {
  marginLeft: "5px",
  color: "$gray-80",

  fontFamily: "$nunito",
  fontWeight: "600px",
  fontSize: "16px",
  lineHeight: "34px",
});
